export enum SectionIds {
  webmastersId = 'webmasters-section',
  advertisersId = 'advertisers-section',
  FAQ = 'FAQ-section',
}
